import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getSuggestedSearchTerms = (): string[] => {
  return getGlobalProperty("suggestedSearchTerms") ?? [];
};
